import { StringRequired } from '../primitive/string';

export const Message = StringRequired.annotate({
  message: 'Vyplňte zprávu!',
});
